/*
This file is located in the main branch
Last time the file was updated (UTC): [11/6/2024 4:35:58AM]
Permissions to update outside the main branch: [true]
*/

import { Form } from '@finbeat/react-toolkit';
import nova from 'logo.svg';
import { PropsWithChildren } from 'react';
import { FieldValues } from 'react-hook-form';
import { Card, CardBody } from 'reactstrap';
import './Window.scss';

export type WindowProps<T extends FieldValues> = PropsWithChildren<{
    onSubmit: (data: T) => void;
    label: string;
}>;

const Window = <T extends FieldValues>({ children, label, onSubmit }: WindowProps<T>) => {
    return (
        <Card className="main-card window">
            <CardBody className="flex-centered window__card-body">
                <div className="window__logo flex-centered">
                    <img src={nova} alt="Nova Horizontal SVG" />
                </div>
                <Form<T> clearAfterSubmit={false} onSubmit={onSubmit} className="window__content">
                    <div className="window__label">{label}</div>
                    {children}
                </Form>
            </CardBody>
        </Card>
    );
};

export default Window;
